import react, { Suspense } from "react";
import OurRoutes from "./route";
import * as Routers from "./router";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function AppRouter() {
  return (
    <Router>
      <Suspense>
        <Routes>
          <Route path={OurRoutes.MainPage} element={<Routers.MainPage />}>
            <Route index element={<Routers.HomePage />} />
            <Route path={OurRoutes.PRIVACY_POLICY} element={<Routers.PRIVACY_POLICY />} />
            <Route path={OurRoutes.TERMS_CONDITION} element={<Routers.TERMS_CONDITION />} />
            <Route path={OurRoutes.REFUND_POLICY} element={<Routers.REFUND_POLICY />}  />
            <Route path={OurRoutes.DISCLAIMER_Cashtap} element={<Routers.DISCLAIMER_Cashtap />}/>
            <Route path={OurRoutes.SUPPORT} element={<Routers.SUPPORT />} />
            <Route path={OurRoutes.MARKET_SIZE} element={<Routers.MARKET_SIZE />} />
            <Route path={OurRoutes.CONTACT_US} element={<Routers.CONTACT_US />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default AppRouter;
